export default {
  endDate: {
    en: 'end date',
    ru: 'Конец периода'
  },
  start: {
    en: 'start date',
    ru: 'Начало'
  },
  end: {
    en: 'end date',
    ru: 'Конец'
  }
};